import { Log } from "src/types.g";
import { parseIfJsonString } from "./utils";

// Helper function to check if a value should be hidden
const shouldHideValue = (value: unknown): boolean => {
  return value === null || value === undefined;
};

export const SimpleLogView = (props: { log: Partial<Log> }): JSX.Element => {
  const dataFields =
    props.log.action === "I"
      ? props.log.changedFields
      : props.log.previousFields;

  return (
    <table className="log-details-table">
      <thead className="table-header">
        <tr>
          <th>Data Field</th>
          <th>Value</th>
        </tr>
      </thead>
      <tbody>
        {dataFields &&
          Object.keys(dataFields)
            .filter((key) => !shouldHideValue(dataFields[key]))
            .map((key) => {
              let value = dataFields[key];
              value = parseIfJsonString(value);

              const isObject = typeof value === "object" && value !== null;

              if (isObject) {
                return (
                  <tr key={key}>
                    <td className="td-key" title={key}>
                      {key}
                    </td>
                    <td className="td-value">
                      <pre className="json-value">
                        {JSON.stringify(value, null, 2)}
                      </pre>
                    </td>
                  </tr>
                );
              }

              return (
                <tr key={key}>
                  <td className="td-key" title={key}>
                    {key}
                  </td>
                  <td className="td-value">{String(value)}</td>
                </tr>
              );
            })}
      </tbody>
    </table>
  );
};
